var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckDisc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "check-a",
    x1: "0%",
    x2: "100%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0BA360"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3CBA92"
  })), /*#__PURE__*/React.createElement("path", {
    id: "check-b",
    d: "M238,60 C215.777778,60 198,77.7777778 198,100 C198,122.222222 215.777778,140 238,140 C260.222222,140 278,122.222222 278,100 C278,77.7777778 260.222222,60 238,60 Z M258.888889,89.7777778 L234.444444,116.444444 C233.555556,117.333333 232.222222,117.777778 231.333333,117.777778 C230.444444,117.777778 229.111111,117.333333 228.222222,116.444444 L217.111111,104.444444 C215.333333,102.666667 215.777778,100 217.555556,98.2222222 C219.333333,96.4444444 222,96.8888889 223.777778,98.6666667 L231.333333,107.111111 L252.666667,84 C254.444444,82.2222222 257.111111,82.2222222 258.888889,83.5555556 C260.666667,84.8888889 260.666667,88 258.888889,89.7777778 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#check-a)",
    transform: "translate(-198 -60)",
    xlinkHref: "#check-b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDisc);
export default __webpack_public_path__ + "static/media/check-disc.638ba89fd74b3675f198791acf0d65cc.svg";
export { ForwardRef as ReactComponent };